import type { ReactNode } from 'react';

import type { LANGUAGE } from '@/types/commonConst';

import { getFeatureMessage } from '..';
import { feedbackMessages } from './messages';

export type FeedbackMessageKey = keyof typeof feedbackMessages;

export const getFeedbackMessage = (
  lang: LANGUAGE,
  key: FeedbackMessageKey,
): ReactNode => {
  return getFeatureMessage(feedbackMessages[key], lang);
};
